import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ProgressShare from "@/pages/ProgressShare";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/share-progress")({
  head: () => seoHead("/share-progress"),
  component: () => (
    <AuthGate><ProgressShare /></AuthGate>
  ),
});
